// extracted by mini-css-extract-plugin
module.exports = {"nomination-status-icon":"NominationStatus_nomination-status-icon__1FKOs","background":"NominationStatus_background__1kiqG"};